import { action } from "typesafe-actions";

export const SET_MICRO_SERVICE = "SET_MICRO_SERVICE";
export const setMicroService = (payload: string) => action(SET_MICRO_SERVICE, payload);
